import http from '@/services/rest/rest.service';

import { IDashboardStatsModel } from '@/entities/dashboard/dashboard-stats-model';

export default {
    dashboard(): Promise<IDashboardStatsModel> {
        return http.get('dashboard');
    }
};
